import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons";

import gridBlocks from "@/assets/images/landing-page/grid blocks.png";
import { Icon } from "@/components";
import { MockupWindow, PlanMockup } from "@/pages/Public/components/ProductMockups";
import { trackCheckCtaClick, trackDirectRegisterClick } from "@/utils/analytics";
import { ROUTE_CONFIG } from "@/routes/config";

export default function LandingLeadMagnetSection() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const ts = (key: string) => t(`questionnaire.landingLeadMagnet.${key}`);

	const bullets = t("questionnaire.landingLeadMagnet.bullets", {
		returnObjects: true,
	}) as string[];

	const handleStartCheck = () => {
		trackCheckCtaClick("lead_magnet");
		navigate("/questionnaire/yes");
	};

	const handleRegister = () => {
		trackDirectRegisterClick("lead_magnet");
		navigate(ROUTE_CONFIG.REGISTER);
	};

	return (
		<footer className="w-full">
			<section
				className="w-full bg-ink text-white relative py-12 sm:py-32 px-4 flex justify-center overflow-hidden"
				style={{ minHeight: 448 }}
			>
				<div
					className="absolute inset-0 bg-no-repeat bg-cover bg-center z-0"
					style={{ backgroundImage: `url(${gridBlocks})` }}
				/>
				<div className="relative z-10 flex flex-col md:flex-row justify-between items-center gap-12 max-w-[1500px] w-full">
					<div className="flex flex-col gap-10 max-w-[694px] w-full">
						<h2 className="font-urbanist font-bold text-white text-[42px] md:text-[52px] leading-[120%]">
							{ts("title")}
						</h2>
						<ul className="flex flex-col gap-3">
							{bullets?.map((bullet) => (
								<li key={bullet} className="flex items-start gap-3">
									<Icon className="w-5 h-5 mt-1 text-success-light" icon={faCircleCheck} />
									<span className="font-urbanist text-[18px] font-medium leading-[150%]">
										{bullet}
									</span>
								</li>
							))}
						</ul>
						<div className="flex flex-col gap-4">
							<button
								className="w-fit rounded-[12px] px-12 py-3 font-urbanist font-medium text-[16px] leading-[22px] bg-white border border-border text-ink hover:bg-accent-tint transition-colors"
								type="button"
								onClick={handleStartCheck}
							>
								{ts("ctaButton")}
							</button>
							<p className="font-urbanist text-[14px] text-white/70">
								{ts("registerHint")}{" "}
								<button
									className="underline text-white/90 hover:text-white"
									type="button"
									onClick={handleRegister}
								>
									{ts("registerLink")}
								</button>
							</p>
						</div>
					</div>

					<div className="w-full max-w-[460px] md:max-w-[560px]">
						<MockupWindow>
							<PlanMockup />
						</MockupWindow>
					</div>
				</div>
			</section>
		</footer>
	);
}
